class LkSidebar {
	constructor(props) {
		this.btn = document.querySelector('.js-back-sidebar');

		if (!this.btn || window.innerWidth > 767) return;

		this.sidebar = document.querySelector('.js-sidebar');
		this.isActive = this.sidebar.classList.contains('active');
		this._init();
	}

	_init() {
		if (this.isActive) {
			if (window.sessionStorage.getItem('lk_sidebar_showed')) {
				this.hide();
			} else {
				this.show();
			}
		}

		window.sessionStorage.setItem('lk_sidebar_showed', '1');

		this.btn.addEventListener('click', this._toggler);
		this.sidebar.addEventListener('click', this._sidebarHandler);
	}

	_sidebarHandler = (e) => {
		const navItem = e.target.closest('.lk-sidebar__nav-link');
		if (!navItem) return;

		const isActiveNavItem = navItem.closest('.lk-sidebar__nav-item.active');
		if (!isActiveNavItem) return;

		e.preventDefault();

		this._toggler();
	}

	_toggler = () => {
		if (this.isActive) {
			this.hide();
		} else {
			this.show();
		}
	}

	show = () => {
		this.sidebar.classList.add('active');
		bodyFixPosition();
		this.isActive = true;
	}

	hide = () => {
		this.sidebar.classList.remove('active');
		bodyUnfixPosition();
		this.isActive = false;
	}
}
